import { render, staticRenderFns } from "./entity-list.vue?vue&type=template&id=4c368483&scoped=true&"
import script from "./entity-list.vue?vue&type=script&lang=js&"
export * from "./entity-list.vue?vue&type=script&lang=js&"
import style0 from "./entity-list.vue?vue&type=style&index=0&id=4c368483&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c368483",
  null
  
)

export default component.exports